var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0833 2.75C20.2055 3.36919 19.2336 3.84277 18.205 4.1525C17.6529 3.51772 16.9192 3.0678 16.1031 2.8636C15.287 2.6594 14.4279 2.71076 13.6419 3.01075C12.8559 3.31074 12.1811 3.84487 11.7086 4.54091C11.2361 5.23695 10.9887 6.06131 11 6.9025V7.81917C9.38909 7.86094 7.79284 7.50366 6.35343 6.77916C4.91402 6.05466 3.67613 4.98542 2.75001 3.66667C2.75001 3.66667 -0.916662 11.9167 7.33334 15.5833C5.44549 16.8648 3.19657 17.5074 0.916672 17.4167C9.16667 22 19.25 17.4167 19.25 6.875C19.2492 6.61967 19.2246 6.36496 19.1767 6.11417C20.1122 5.19154 20.7724 4.02665 21.0833 2.75Z",
    stroke: "#1E1E1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.d931ceb7898793403a238251ab178f0e.svg";
export { ForwardRef as ReactComponent };